if (!customElements.get("sticky-content")) {
    class a extends HTMLElement {
        constructor() {
            super();
            this.media = window.matchMedia("(min-width: 992px)");
            this.media.addEventListener("change", () => this.onResize());
            this.sticky = void 0;
            this.content = this.querySelector("[data-sticky-content]");
            this.settings = {
                topSpacing: this.content.getAttribute("data-top-spacing") ? parseInt(this.content.getAttribute("data-top-spacing")) : 24,
                bottomSpacing: this.content.getAttribute("data-bottom-spacing") ? parseInt(this.content.getAttribute("data-bottom-spacing")) : 0
            };
            window.addEventListener("resize", () => {
                this.resize()
            });
            this.onResize();

            // Setup ResizeObserver to update sticky bounds when content height changes (like expanding drawers or changing variants)
            this.resizeObserver = new ResizeObserver(() => {
                if (this.sticky && typeof this.sticky.updateSticky === 'function') {
                    this.sticky.updateSticky();
                } else if (this.sticky) {
                    // fallback if updateSticky isn't available, but try to trigger resize recalculation
                    window.dispatchEvent(new Event('resize'));
                }
            });
            this.resizeObserver.observe(this.content);
        }
        resize() {
            void 0 !== this.sticky && (this.sticky.sidebarInner.style.width = this.content.offsetWidth + "px")
        }
        /**
         * Opakowanie tworzy biblioteka, wiec nie ma go w Liquidzie i nie da sie
         * opisac arkuszem po klasie z motywu - stad styl ustawiany tutaj.
         *
         * PULAPKA (migajaca kolumna na karcie produktu): biblioteka przelacza
         * opakowanie miedzy "position: fixed" i "position: relative", a przy
         * pozycjonowaniu bezwzglednym marginesy dzieci NIE wychodza na zewnatrz.
         * Gorny margines naglowka (18 px) raz byl wiec liczony do wysokosci
         * opakowania, raz nie. Biblioteka podaje te wysokosc opakowaniu
         * zewnetrznemu, obserwator rozmiaru (nizej) budzil sie na tej zmianie
         * i przeliczal stan od nowa - kolumna skakala co klatke o 18 px.
         *
         * "flow-root" domyka marginesy dzieci w obu stanach, wiec wysokosc jest
         * ta sama i petla w ogole nie powstaje. Widocznie nic sie nie zmienia -
         * to dokladnie ten uklad, ktory kolumna miala w stanie przyklejonym.
         */
        lockInnerHeight() {
            if (this.sticky && this.sticky.sidebarInner) {
                this.sticky.sidebarInner.style.display = "flow-root";
            }
        }
        onResize() {
            this.media.matches ? void 0 === this.sticky && ((this.sticky = new StickySidebar(this.content, {
                topSpacing: this.settings.topSpacing,
                bottomSpacing: this.settings.bottomSpacing
            })), this.lockInnerHeight()) : void 0 !== this.sticky && (this.sticky.destroy(), this.sticky = void 0)
        }
        disconnectedCallback() {
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.sticky) this.sticky.destroy();
        }
    }
    customElements.define("sticky-content", a)
}